module.exports = __webpack_public_path__ + "img/Icons.aa1e0907.svg";